export default __webpack_public_path__ + "static/media/banner_home.efc1935e.png";